import React from 'react'

import { Icon, ChevronLeft, ChevronRight, Close } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { array, string, bool, func } from 'prop-types'

function SubcategoryMenu({ subcategories, categoryTitle = '', isOpen, onClose, handleLinkClick }) {
  const nonNullCategories = subcategories.filter((subcategory) => subcategory !== null)

  return (
    <div className={`subcategory-menu ${isOpen ? 'subcategory-menu--open' : ''}`}>
      <div className="subcategory-menu__header">
        <div className="subcategory-menu__header-content">
          <Icon onClick={onClose} color="dark" svgComponent={ChevronLeft} />
          <span className="subcategory-menu__header-title">{categoryTitle}</span>
        </div>
        <Icon onClick={onClose} color="dark" svgComponent={Close} />
      </div>
      <ul className="subcategory-menu__list">
        {nonNullCategories.map((subcategory) => (
          <li key={subcategory.title || subcategory.name} className="subcategory-menu__item">
            <a
              href={subcategory.path}
              className="subcategory-menu__link"
              onClick={(event) => handleLinkClick(event, subcategory.path)}
            >
              {subcategory.title || subcategory.name}
              <div className="subcategory-menu__link-icon">
                <Icon color="dark" svgComponent={ChevronRight} />
              </div>
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

SubcategoryMenu.propTypes = {
  subcategories: array.isRequired,
  categoryTitle: string,
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  handleLinkClick: func.isRequired,
}

export default SubcategoryMenu
